import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Slider from "react-slick";

const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    centerMode: false,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
};

const videoList = [
    {
        link: "https://www.youtube.com/embed/3plvEfC5OB8?si=EsXgnvJBRzXPfoaj",
    },
    {
        link: "https://www.youtube.com/embed/Li4Oq59Ywv8?si=I5sjpwGv52burrp9",
    },
    {
        link: "https://www.youtube.com/embed/XOFvdZHOwZQ?si=s3o8SlRLFtds_3LR",
    },
    {
        link: "https://www.youtube.com/embed/neI0TNFpPjE?si=hynIO5O7rsqQij50",
    },
    {
        link: "https://www.youtube.com/embed/Tg4ETZjNRLA?si=f2E0x-1z4Lrjga4x",
    },
    {
        link: "https://www.youtube.com/embed/S0CF9HRwB-k?si=PqwILNSridooqs0A",
    },
    {
        link: "https://www.youtube.com/embed/NjPQFhPqMtg?si=X1QBoY3Vjusx11k_",
    },
    {
        link: "https://www.youtube.com/embed/usFj-Ixmzzs?si=agBpJFUSXEZ60dZ6",
    }
];
export default function Videos() {
    React.useEffect(() => {
            const termsAndConditionsView = document.getElementById('Videos');
            if (termsAndConditionsView) {
                termsAndConditionsView.scrollIntoView({ behavior: 'smooth' });
            }
        }, []);
    return (
        <Container id="Videos" sx={{ 
            my: { sm: 0, xs: 5 },
            py: { sm: 15, xs: 10 },
        }} fixed>
            <Box sx={{  minHeight: '50vh' }}>
                <Typography variant="h6" component="h1" align="center">
                    You can checkout our offical youtube channel <a href="https://www.youtube.com/@aliatistech" target="_blank">Aliatis</a>
                </Typography>
                <Typography variant="body1" component="h1" align="center">
                    Our featured video this week              
                </Typography>
                <br/>
                <Box
                    sx={{ 
                        paddingBottom: 5,
                        paddingLeft: {sm: 10, xs: 2},
                        height: {sm: 500, xs: 350},
                    }}>  
                    <iframe 
                        width="100%" 
                        height="100%"
                        src="https://www.youtube.com/embed/3DK1wDyjoQk?si=tmvT0_PAJhbeHhrH"
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerpolicy="strict-origin-when-cross-origin" 
                        allowfullscreen
                    ></iframe>                
                </Box>
                <Typography variant="body1" component="h1" align="center">
                    Check our most recent videos         
                </Typography>
                <br/>
                <Box 
                    sx={{
                        marginLeft: {sm: '0vw', xs: '5vw'},
                        minWidth: {sm: '70vw', xs: 'auto'},
                        px: { sm: 6, xs: 6 },
                    }} className='slider-container'>
                    <Slider {...settings}>
                    {videoList.map((item) => (
                        <iframe 
                            width="300" 
                            height="215"
                            src={item.link}
                            title="YouTube video player" 
                            frameborder="1" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen
                        ></iframe> 
                    ))}
                    </Slider>
                    
                </Box>
            </Box>
        </Container>
    );
}